"use client"

import { createContext, useContext, useEffect, useState } from "react"
import { getCookie, setCookie, deleteCookie } from "cookies-next"

type SucursalContextType = {
  sucursal: string
  changeSucursal: (sucursal: string) => void
  clearSucursal: () => void
}

export const SucursalContext = createContext<SucursalContextType | null>(null)

type SucursalProviderProps = {
  children: React.ReactNode
}

export const SucursalProvider: React.FC<SucursalProviderProps> = ({
  children
}) => {
  const [sucursal, setSucursal] = useState<string>("")

  const changeSucursal = (sucursal: string) => {
    setSucursal(sucursal)
    setCookie("_suc", sucursal)
  }

  const clearSucursal = () => {
    setSucursal("")
    deleteCookie("_suc")
  }
  useEffect(() => {
    const sucursal = getCookie("_suc")
    if (sucursal) {
      setSucursal(sucursal)
    }
  }, [])

  return (
    <SucursalContext.Provider
      value={{ sucursal, changeSucursal, clearSucursal }}
    >
      {children}
    </SucursalContext.Provider>
  )
}

export const useSucursalContext = () => {
  const context = useContext(SucursalContext)

  if (context === null) {
    throw new Error("SucursalContext must be used within a SucursalProvider")
  }

  return context
}
